export default {
  title: "الأسئلة الشائعة",
  subtitle: "إدارة الأسئلة الشائعة",

  addNew: "إضافة سؤال جديد",
  createFaq: "إنشاء سؤال",
  editFaq: "تعديل السؤال",
  deleteFaq: "حذف السؤال",

  actions: {
    back: "رجوع",
    update: "تحديث",
    updating: "جاري التحديث..."
  },

  fields: {
    category: "التصنيف",
    question: "السؤال",
    answer: "الإجابة",
    displayOrder: "ترتيب العرض",
    isActive: "نشط"
  },

  placeholders: {
    category: "اختر التصنيف",
    question: "أدخل السؤال بالعربية والإنجليزية",
    answer: "أدخل الإجابة بالعربية والإنجليزية"
  },

  messages: {
    createSuccess: "تم إنشاء السؤال بنجاح",
    createError: "فشل في إنشاء السؤال",
    updateSuccess: "تم تحديث السؤال بنجاح",
    updateError: "فشل في تحديث السؤال",
    deleteSuccess: "تم حذف السؤال بنجاح",
    deleteError: "فشل في حذف السؤال",
    deleteConfirm: "هل أنت متأكد من حذف هذا السؤال؟",
    noFaq: "لا توجد أسئلة شائعة",
    fetchError: "فشل في جلب الأسئلة الشائعة"
  },

  validation: {
    categoryRequired: "التصنيف مطلوب",
    questionRequired: "السؤال مطلوب",
    answerRequired: "الإجابة مطلوبة",
    fillAllFields: "يرجى تعبئة جميع الحقول المطلوبة"
  },

  table: {
    displayOrder: "الترتيب",
    category: "التصنيف",
    question: "السؤال",
    answer: "الإجابة",
    status: "الحالة",
    actions: "الإجراءات"
  },

  status: {
    active: "نشط",
    inactive: "غير نشط"
  },

  breadcrumbs: {
    faq: "الأسئلة الشائعة",
    create: "إنشاء سؤال",
    edit: "تعديل السؤال"
  }
};
